<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_3" title="Veritas Forum"></h2>
<p class="first"><em>We create for the exploration of true life.</em></p>
<p class="first"><em>We seek to inspire the shapers of tomorrow’s culture to connect their hardest questions with the person and story of Jesus Christ.</em></p>
<p class="first">For hundreds of video and audio recordings of events like those presented in this volume, visit The Veritas Forum website: <a href="http://www.veritas.org" target="_blank">www.veritas.org</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Veritas.vue?6d3c39aa